import { LocationResponse } from '../types/civic-info-types'
import { fetchNetlify } from './netlify'

export const fetchLocationData = async (address: string) =>
  await fetchNetlify<LocationResponse>(`/.netlify/functions/civic-info?address=${address}`)
